import { render, staticRenderFns } from "./CrewPageEdit.vue?vue&type=template&id=bf11b942&scoped=true&"
import script from "./CrewPageEdit.vue?vue&type=script&lang=js&"
export * from "./CrewPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./CrewPageEdit.vue?vue&type=style&index=0&id=bf11b942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf11b942",
  null
  
)

export default component.exports